import {
  BD_GET_MATERIALSTANDARD_LISTING,
  BD_GET_MATERIALSTANDARD_LISTING_SUCCESS,
  BD_GET_MATERIALSTANDARD_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    bdMaterialStandard: null,
  }
  
  const bdMaterialStandard = (state = initialState, action) => {
    switch (action.type) {
      case BD_GET_MATERIALSTANDARD_LISTING:
        state = {
          ...state,
          loading: true,
          bdMaterialStandard: action.payload,
        }
        break
      case BD_GET_MATERIALSTANDARD_LISTING_SUCCESS:
        state = { ...state, loading: false, bdMaterialStandard: action.payload }
        break
      case BD_GET_MATERIALSTANDARD_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default bdMaterialStandard
  